import { API_URL } from "../../../../utils/constant";

const BillFormat3mmPage = ({ companyData, data }) => {
  const isSameState = companyData?.state === data.Customer?.state;
  
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  };

  const formatCurrency = (amount) => {
    return (parseFloat(amount) || 0).toFixed(2);
  };

  const itemsHtml = data.product_data.map(item => {
    const total = (item.amount || 0).toFixed(2);
    // Truncate product name for thermal roll
    const shortName = item.product_name.length > 25 ? item.product_name.substring(0, 22) + '...' : item.product_name;
    
    return `
      <div style="margin-bottom: 4px;">
        <div style="display: flex; justify-content: space-between; font-weight: bold;">
          <span>${shortName}</span>
        </div>
        <div style="display: flex; justify-content: space-between; font-size: 9px;">
          <span>${item.qty} x ${formatCurrency(item.price)}</span>
          <span>${total}</span>
        </div>
      </div>
    `;
  }).join('');

  return `
    <!DOCTYPE html>
    <html>
      <head>
        <style>
          @page { size: 80mm auto; margin: 0; }
          body { 
            font-family: 'Courier New', Courier, monospace; 
            width: 80mm; 
            margin: 0; 
            padding: 5mm; 
            font-size: 10px; 
            line-height: 1.2;
            color: #000;
          }
          .center { text-align: center; }
          .bold { font-weight: bold; }
          .header { margin-bottom: 10px; border-bottom: 1px dashed #000; padding-bottom: 5px; }
          .company-name { font-size: 14px; font-weight: bold; margin-bottom: 2px; text-transform: uppercase; }
          .divider { border-top: 1px dashed #000; margin: 5px 0; }
          .item-row { margin-bottom: 5px; }
          .total-section { margin-top: 10px; border-top: 1px solid #000; padding-top: 5px; }
          .flex-between { display: flex; justify-content: space-between; }
          .grand-total { font-size: 14px; font-weight: bold; margin-top: 5px; border-top: 1px double #000; border-bottom: 1px double #000; padding: 3px 0; }
          .footer { margin-top: 15px; font-size: 9px; text-align: center; }
        </style>
      </head>
      <body>
        <div class="header center">
          ${companyData.posLogo ? `<img src="${API_URL}${companyData.posLogo}" style="max-width: 40mm; max-height: 20mm; margin-bottom: 5px;"/><br>` : ''}
          <div class="company-name">${companyData.company_name}</div>
          <div>${companyData.register_address || ''}</div>
          <div>${companyData.city || ''}, ${companyData.state || ''}</div>
          <div>GSTIN: ${companyData.gst_number || ''}</div>
          <div>Mob: ${companyData.mobile_no || ''}</div>
        </div>

        <div class="flex-between">
          <span>Inv: ${data.bill_no}</span>
          <span>${formatDate(data.createdAt)}</span>
        </div>
        <div class="flex-between" style="margin-bottom: 5px;">
          <span>Time: ${formatTime(data.createdAt)}</span>
          <span>Mode: ${data.mode_of_payment.toUpperCase()}</span>
        </div>

        ${data.Customer?.name ? `
          <div class="divider"></div>
          <div class="bold">Customer: ${data.Customer.name}</div>
          ${data.Customer.phone ? `<div>Mob: ${data.Customer.phone}</div>` : ''}
        ` : ''}

        <div class="divider"></div>
        <div class="bold" style="display: flex; justify-content: space-between; margin-bottom: 5px;">
          <span>ITEM DESCRIPTION</span>
          <span>AMOUNT</span>
        </div>
        ${itemsHtml}

        <div class="total-section">
          <div class="flex-between">
            <span>Sub-Total:</span>
            <span>${formatCurrency(data.total + (data.discountAmount || 0) - (data.tax || 0))}</span>
          </div>
          ${data.discountAmount > 0 ? `
          <div class="flex-between">
            <span>Discount:</span>
            <span>-${formatCurrency(data.discountAmount)}</span>
          </div>` : ''}
          <div class="flex-between">
            <span>GST Amount:</span>
            <span>${formatCurrency(data.tax || 0)}</span>
          </div>
          <div class="grand-total flex-between">
            <span>NET PAYABLE:</span>
            <span>₹${formatCurrency(data.total)}</span>
          </div>
        </div>

        <div class="footer">
          <div class="bold">THANK YOU! VISIT AGAIN</div>
          <div style="margin-top: 5px; font-style: italic;">
            ${companyData.footer_statement || 'Goods once sold will not be taken back.'}
          </div>
          <div style="margin-top: 8px;">Software By: Beginit4u.com</div>
        </div>
      </body>
    </html>
  `;
};

export default BillFormat3mmPage;
